import { MODULE_LINK_TYPE } from '../constants';
export const ADMIN = {
  [MODULE_LINK_TYPE.BUILD]: (moduleId: string, seriesId: string) =>
    `/${moduleId}/edit?series=${seriesId}#/build`,
  [MODULE_LINK_TYPE.INVITE_TRACK]: (moduleId: string, seriesId: string) =>
    `/${moduleId}/edit?series=${seriesId}#/track`,
  [MODULE_LINK_TYPE.ANALYTICS]: (moduleId: string, seriesId: string, moduleName: string) =>
    `modules/${moduleId}/mission/learners?gameType=mission&inSeries=${seriesId}&name=${moduleName}`,
};

export const LEARNER = {};
